export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";